import { Link, useNavigate } from 'react-router-dom'
import Logo from '../../components/Logo.jsx'
import './legal.css'

export default function LegalLayout({ eyebrow, title, updatedAt, sections, children }) {
  const navigate = useNavigate()

  return (
    <div className="legal-shell">
      <header className="legal-topbar">
        <Link to="/login" className="legal-brand">
          <Logo height={16} />
        </Link>
        <div className="legal-topbar-actions">
          <Link to="/privacy" className="btn btn-ghost btn-sm">
            Privacidade
          </Link>
          <Link to="/terms" className="btn btn-ghost btn-sm">
            Termos
          </Link>
          <button type="button" className="btn btn-outline btn-sm" onClick={() => navigate('/login')}>
            Entrar
          </button>
        </div>
      </header>

      <div className="legal-hero">
        <span className="legal-eyebrow">{eyebrow}</span>
        <h1 className="legal-title">{title}</h1>
        <p className="legal-meta">
          Última atualização: <strong>{updatedAt}</strong>
        </p>
      </div>

      <div className="legal-body">
        <div className="legal-layout">
          <nav className="legal-toc" aria-label="Índice">
            <div className="legal-toc-label">Nesta página</div>
            <ol>
              {sections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>{section.title}</a>
                </li>
              ))}
            </ol>
          </nav>

          <article className="legal-content">{children}</article>
        </div>
      </div>

      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <span className="legal-footer-brand">
            <Logo height={13} />
          </span>
          <div className="legal-footer-links">
            <Link to="/privacy">Política de Privacidade</Link>
            <Link to="/terms">Termos de Serviço</Link>
            <Link to="/login">Entrar</Link>
          </div>
          <div className="legal-footer-copy">
            © {new Date().getFullYear()} TITAM. Todos os direitos reservados.
          </div>
        </div>
      </footer>
    </div>
  )
}
